// extracted by mini-css-extract-plugin
var _1 = "loader_loader";
export { _1 as "loader" }
